import { Fragment, useState } from "react";
import { PopoverButton } from "../../atoms/PopoverButton/PopoverButton";
import { ButtonPropsT, StyledButton } from "../../atoms/Button/Button";
import HorizontalDivider from "../../atoms/Divider/HorizontalDivider";
import styles from "./hamburgerActions.module.scss";

export type HamburgerActionT = {
  title: string;
  onClick?: VoidFunction;
  disabled?: boolean;
  divider?: boolean;
};

export type ButtonActionT = ButtonPropsT & {
  divider?: boolean;
};

type HamburgerActionsPropsT = {
  actions: HamburgerActionT[] | undefined;
  buttonActions: ButtonActionT[] | undefined;
  className?: string;
};

export function HamburgerActions({
  actions,
  buttonActions,
  className,
}: HamburgerActionsPropsT) {
  const [open, setOpen] = useState(false);

  return (
    <PopoverButton
      id="subheaderActions"
      className={className}
      isOpen={open}
      toggle={() => setOpen(!open)}
      color="dark"
      outline
      icon="pending"
    >
      <div className={styles.body}>
        <>
          {buttonActions &&
            buttonActions.map((action, index) => {
              const { divider, ...props } = action;
              return (
                <Fragment key={`buttonAction-${props.title}-${index}`}>
                  <StyledButton
                    {...props}
                    onlyIcon={false}
                    onlyIconOnMobile={false}
                    icon={undefined}
                    className={styles.button}
                    color="link"
                    onClick={(event) => {
                      setOpen(false);
                      if (props.onClick) {
                        props.onClick(event);
                      }
                    }}
                  />
                  {((index === buttonActions.length - 1 &&
                    actions &&
                    actions.length > 0) ||
                    divider) && <HorizontalDivider width={80} />}
                </Fragment>
              );
            })}
          {actions &&
            actions.map((action, index) => {
              const { divider, ...rest } = action;
              return (
                <Fragment key={`action-${rest.title}-${index}`}>
                  <StyledButton
                    {...rest}
                    className={styles.button}
                    color="link"
                    onClick={() => {
                      setOpen(false);
                      if (rest.onClick) {
                        rest.onClick();
                      }
                    }}
                  />
                  {divider && <HorizontalDivider width={80} />}
                </Fragment>
              );
            })}
        </>
      </div>
    </PopoverButton>
  );
}
